import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section`
	background: ${palette('buttonPrimaryBg')};
	display: grid;
	margin-bottom: 60px;

	${minWidth('desktop')} {
		grid-template-columns: calc(100% - 700px) 700px;
		height: 545px;
		margin-bottom: 100px;
	}
`;
export const Copy = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	max-width: 560px;
	padding: 40px 20px;

	${minWidth('tablet')} {
		margin: 0 auto;
		padding: 16px 40px;
	}
`;
export const Heading = styled(Text).attrs({
	el: 'h2',
	color: 'white',
	noMargin: true,
})`
	&&& {
		font-size: 24px;
		line-height: 1.5;
		margin-bottom: 12px;

		${minWidth('tablet')} {
			font-size: 31.5px;
		}
	}
`;
export const Body = styled(Text).attrs({
	el: 'p',
	color: 'white',
})`
	&&& {
		margin-bottom: 24px;
	}
`;
export const ImageContainer = styled.div`
	height: 282px;
	mask-image: linear-gradient(to top, rgba(0, 0, 0, 1) 150px, transparent 100%);
	position: relative;

	${minWidth('desktop')} {
		height: auto;
		mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 500px, transparent 100%);
		width: 700px;
	}

	${minWidth('desktop')} {
		mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 300px, transparent 100%);
	}
`;
